import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Taxi = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.772 10.156l-1.368-4.105A2.995 2.995 0 0016.559 4H14V2h-4v2H7.441a2.995 2.995 0 00-2.845 2.051l-1.368 4.105A2.003 2.003 0 002 12v5c0 .753.423 1.402 1.039 1.743-.013.066-.039.126-.039.195V21a1 1 0 001 1h1a1 1 0 001-1v-2h12v2a1 1 0 001 1h1a1 1 0 001-1v-2.062c0-.069-.026-.13-.039-.195A1.993 1.993 0 0022 17v-5c0-.829-.508-1.541-1.228-1.844zM4 17v-5h16l.002 5H4zM7.441 6h9.117c.431 0 .813.274.949.684L18.613 10H5.387l1.105-3.316A1 1 0 017.441 6z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 6.5,
    cy: 14.5,
    r: 1.5,
    key: "k1"
  }), React.createElement("circle", {
    cx: 17.5,
    cy: 14.5,
    r: 1.5,
    key: "k2"
  }));
});
Taxi.displayName = 'Taxi';
export var TaxiDimensions = {
  height: 24,
  width: 24
};